<template lang="pug">
.container.grid-lg
  page-title(
    title='Saldo',
    icon='fas fa-piggy-bank',
    subtitle='Detalhamento do seu saldo disponível'
  )
    div(slot='actions', v-if='current && iuguInfo')
      router-link.btn.btn-primary(
        :disabled='convertToFloat(iuguInfo.balance_available_for_withdraw) === 0 || !current["is_verified?"]',
        :to='{ name: "balances.current.request-withdraw" }'
      )
        i.fas.fa-fw.fa-hand-holding-usd
        |
        | Sacar
  .flex-centered.content-full-height.loading.loading-lg(v-if='loading')
  div(v-else-if='current')
    div(v-if='iuguInfo["is_verified?"]')
      .columns
        .column.col-4.col-md-6.col-sm-12.my-2
          info-card(title='Disponível', icon='fas fa-money-bill-alt')
            .card-body(slot='card-body')
              .flex-centered
                .h2.text-bold.ml-1.text-success {{ iuguInfo.balance_available_for_withdraw }}
            .card-footer.text-center(slot='card-footer')
              cite.text-small Valor disponível para saque
        .column.col-4.col-md-6.col-sm-12.my-2
          info-card(title='Aguardando', icon='fas fa-money-bill-alt')
            .card-body(slot='card-body')
              .flex-centered
                .h2.text-bold.ml-1.text-warning {{ iuguInfo.protected_balance }}
            .card-footer.text-center(slot='card-footer')
              cite.text-small Você poderá sacar este valor em breve
      .columns(v-if='iuguInfo.informations && iuguInfo.informations.length')
        .column.col-8.col-md-12.col-sm-12.my-2
          bank-account-info(:informations='iuguInfo.informations')
    .flex-centered.content-full-height(v-else-if='!current["is_verified?"]')
      .empty
        .empty-icon
          i.fas.fa-user-times.fa-3x
        p.empty-title.h5 Conta bancária não cadastrada
        p.empty-subtitle Agora você precisa adicionar um domicílio bancário para verificar sua conta
        .empty-action
          router-link.btn.btn-primary(
            :to='{ name: "balances.current.form-verify" }'
          )
            i.fas.fa-fw.fa-piggy-bank
            |
            | Adicionar conta bancária
  div(v-else-if='error')
    .flex-centered.content-full-height(v-if='error.code === "recordNotFound"')
      .empty
        .empty-icon
          i.fas.fa-piggy-bank.fa-3x
        p.empty-title.h5 Conta digital inexistente
        p.empty-subtitle Você precisa criar uma conta digital para poder receber
        .empty-action
          a.btn.btn-primary(@click='create', :class='{ loading: creating }')
            i.fas.fa-fw.fa-piggy-bank
            |
            | Adicionar conta digital
    .flex-centered.content-full-height(v-else) #[error-box(:error='error')]
  router-view(:fetch-info='fetchInfo')
</template>

<script>
import iuguSubAccounts from '@/services/api/iuguSubAccounts'
import { mapActions, mapState } from 'vuex'
import BankAccountInfo from './components/BankAccountInfo'

export default {
  data() {
    return {
      creating: false,
      loading: false,
      error: null,
    }
  },
  components: { BankAccountInfo },
  computed: {
    ...mapState('iuguSubAccounts', ['current']),
    subAccount() {
      return this.current.subAccount
    },
    iuguInfo() {
      return this.current ? this.current.iuguInfo : null
    },
  },
  methods: {
    ...mapActions('iuguSubAccounts', ['fetchCurrent']),
    async fetchInfo() {
      try {
        this.loading = true
        await this.fetchCurrent()
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },

    async create() {
      try {
        this.creating = true
        await iuguSubAccounts.create()
        this.fetchInfo()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.creating = false
      }
    },

    // Necessário pois os dados da Iugu vem como: R$ 0.000,00
    convertToFloat(str = '') {
      const value = str
        .replace(/\./g, '')
        .replace(/\,/g, '.')
        .replace(/\$ /g, '')
        .replace(/[^0-9.]/, '')

      return Number(value)
    },
  },
  async created() {
    this.fetchInfo()
  },
}
</script>
